import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import { useAuth } from './useAuth'

interface RoleGetResponse {
  representative: string[]
}

interface ResultRoleGet {
  success: boolean
  info?: RoleGetResponse
  message?: string
}

interface CG01RoleGetProps {
  execRoleGet: (tenant: string, role: 'representative') => Promise<ResultRoleGet>
  loading: loadStatus
}

// CG01 ロール割当済みユーザーID取得
export const useCG01RoleGet = (): CG01RoleGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execRoleGet = async (tenant: string, role: 'representative') => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.get(
        `${baseUrl}${stage}${apiUrl.tenantsPath}${tenant}/roles`,
        {
          headers: header,
          params: { role },
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }

      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execRoleGet, loading }
}
